const B_1 = [
    {
        title: '云签章',
        path: '/bidding/yqz/yqz/index'
    }
]

export default {
    path: 'yqz',
    component: () => import(/*webpackChunkName: 'yqz'*/ '@layout/empty'),
    children: [
        {
            path:"index",
            component: () => import(/*webpackChunkName: 'yqz'*/'@views/bidding/views/yqz/index'),
            meta: {
                title: '云签章',
                topNav: true,
                bread: B_1
            },
        }
    ]
}
